module.exports = __webpack_public_path__ + "img/migration.b14dcd85.png";